import { Component, OnInit } from '@angular/core';

// TODO: START ###### >>> DUMMY CODE FROM IDMSUI <<< ######
export interface PeriodicElement {
    Item_name: string;
    Status: string;
    comments: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
    { Item_name: '', Status: '', comments: '' },
    { Item_name: '', Status: '', comments: '' },
    { Item_name: '', Status: '', comments: '' },
    { Item_name: '', Status: '', comments: '' },
];

@Component({
    selector: 'app-data-table',
    templateUrl: './data-table.component.html',
    styleUrls: ['./data-table.component.scss'],
    standalone: false
})
export class DataTableComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}

    displayedColumns: string[] = ['Item_name', 'Status', 'comments'];
    dataSource = ELEMENT_DATA;
}
